export { default as Loading } from './Loading';



// WEBPACK FOOTER //
// ./src/components/Loading/index.ts